export const UPDATE_AD_BLOCKERS = 'UPDATE_AD_BLOCKERS';

export const updateAdBlockers = (payload = '') => ({
    type: UPDATE_AD_BLOCKERS,
    payload,
});

export default (state = '', action) =>
    action.type === UPDATE_AD_BLOCKERS ? action.payload : state;
